import { MapPin, Users } from "@phosphor-icons/react";

const Chips = ({ items, cls }) => (
  <div className="flex flex-wrap gap-1.5">
    {items.map((s) => <span key={s} className={`rounded-full px-2.5 py-0.5 text-xs ${cls}`}>{s}</span>)}
  </div>
);

export const MemoryBody = ({ event }) => {
  const strengths = event.reflections_strengths || [];
  const lessons = event.reflections_lessons || [];
  const feelings = event.feelings || [];
  return (
    <div data-testid="memory-full" className="space-y-4">
      {event.subtype && <p className="-mt-2 text-[#8A7F76]">{event.subtype}</p>}
      {event.significant_people && (
        <p className="flex items-center gap-1 text-sm text-[#8A7F76]"><Users size={15} weight="duotone" /> {event.significant_people}</p>
      )}
      {event.location && (
        <p className="flex items-center gap-1 text-sm text-[#8A7F76]"><MapPin size={15} weight="duotone" /> {event.location}</p>
      )}
      {event.description && <p data-testid="memory-description" className="whitespace-pre-line leading-relaxed text-[#4A4540]">{event.description}</p>}
      {event.prompt_answer && (
        <div className="rounded-lg border border-[#4A4540]/10 bg-white p-4">
          {event.prompt_question && <p className="text-xs italic text-[#8A7F76]">{event.prompt_question}</p>}
          <p className="mt-1 font-serif text-lg leading-snug text-[#4A4540]">{event.prompt_answer}</p>
        </div>
      )}
      {event.photo_reminder && (
        <p className="text-sm text-[#6B635B]"><span className="font-medium text-[#2C2A28]">Photo reminder:</span> {event.photo_reminder}</p>
      )}
      {feelings.length > 0 && <Chips items={feelings} cls="bg-[#DDA77B]/25 text-[#8A5A2B]" />}
      {strengths.length > 0 && (
        <div><p className="mb-1.5 text-xs uppercase tracking-wide text-[#7EA193]">What this taught me</p><Chips items={strengths} cls="bg-[#7EA193]/20 text-[#4A6B5D]" /></div>
      )}
      {lessons.length > 0 && (
        <div><p className="mb-1.5 text-xs uppercase tracking-wide text-[#8A7F76]">What I'd do differently</p><Chips items={lessons} cls="bg-[#8A7F76]/15 text-[#6A5F56]" /></div>
      )}
    </div>
  );
};
